import React from "react";


export const SystemContext = React.createContext('home');
